import React from 'react';
import { GuidedProgressBar } from './GuidedProgressBar';

export interface GuidedHeaderBandProps {
  done: number;
  total: number;
}

/** Thin frosted band rendered above capture screens (audio, photo,
    video, etc.) when the participant is in a guided one_time study.
    Provides continuous visibility of progress while recording. Renders
    via fixed/absolute positioning at the top of the viewport so it
    overlays existing capture chrome without re-wiring those screens.
    pointer-events: none on the band itself so it can't intercept
    capture controls — see Guided.css. */
export const GuidedHeaderBand: React.FC<GuidedHeaderBandProps> = ({ done, total }) => (
  <div className="gd-header-band" aria-hidden="true">
    <GuidedProgressBar total={total} current={done} />
  </div>
);
